import { MisoItem } from '@miso.ai/client-sdk';
import misoClient from 'apis/miso';
import { useQuery } from 'react-query';
import { UseQueryHook } from './types';

type UseQueryMisoSemanticSearchDependencies = {
  query: string;
  enabled: boolean;
};

const semanticSearch = (query: string): Promise<Array<MisoItem>> =>
  misoClient.semanticSearch(query);

const useQueryMisoSemanticSearch: UseQueryHook<
  UseQueryMisoSemanticSearchDependencies,
  Array<MisoItem>
> = ({ query, enabled }) => {
  const { data, isLoading, refetch } = useQuery(
    ['useQueryMisoSemanticSearch', query],
    () => semanticSearch(query),
    { enabled }
  );

  return {
    data,
    isLoading,
    refetch,
  };
};

export default useQueryMisoSemanticSearch;
